<template>
  <div class="w-[7rem] mx-auto">
    <Doughnut
      id="my-chart-id"
      :options="chartOptions"
      :data="chartData"
      ref="chart"
      :plugins="plugins"
    />
  </div>
</template>
  
  <script>
import { Doughnut } from "vue-chartjs";
import "chartjs-plugin-datalabels";

export default {
  name: "ProductDonutChart",
  props: ["product"],
  components: { Doughnut },
  data() {
    return {
      chartData: {
        datasets: [
          {
            data: this.calculateChartData(),
            backgroundColor: [this.getChartColor(), "#D9DBE0"],
          },
        ],
      },
      chartOptions: {
        cutout: "80%",
        responsive: true,
        animation:false,
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return (
                data["labels"][tooltipItem["index"]] +
                ": " +
                data["datasets"][0]["data"][tooltipItem["index"]] +
                "%"
              );
            },
          },
        },
      },
      plugins: [this.centerText()],
    };
  },

  mounted() {
    this.getChartColor();
  },

  computed: {
    graphData() {
      const consumedProduct =
        this.product.maxCapacity - this.product.currentQuantity;
      const consumedPercent =
        (consumedProduct * 100) / this.product.maxCapacity;
      const availablePercent =
        (this.product.currentQuantity * 100) / this.product.maxCapacity;

      this.chartData.datasets[0].data = [availablePercent, consumedPercent];
    },
  },

  methods: {
    getChartColor() {
      if (this.product.depotProductName.toLowerCase() == "pms") {
        return "green";
      }
      if (this.product.depotProductName.toLowerCase() == "ago") {
        return "#3B00ED";
      }
      if (this.product.depotProductName.toLowerCase() == "lpg") {
        return "#E99200";
      }
      if (this.product.depotProductName.toLowerCase() == "dpk") {
        return "#F01727";
      }
      if (this.product.depotProductName.toLowerCase() == "lpfo") {
        return "purple";
      }
    },
    calculateChartData() {
      const consumedProduct =
        this.product.maxCapacity - this.product.currentQuantity;
      const consumedPercent =
        (consumedProduct * 100) / this.product.maxCapacity;
      const availablePercent =
        (this.product.currentQuantity * 100) / this.product.maxCapacity;

      return [availablePercent.toFixed(1), consumedPercent.toFixed(1)];
    },
    afterDatasetDraw(chart) {
      const { ctx } = chart;
      ctx.textAlign = "center";
      ctx.font = "12px";
      const text = this.product.depotProductName;
      const x = chart.chartArea.left + chart.chartArea.right / 2;
      const y = chart.chartArea.top + chart.chartArea.bottom / 2;
      ctx.fillText(text, x, y);
    },

    centerText() {
      return {
        id: "centerText",
        afterDatasetDraw: this.afterDatasetDraw,
      };
    },
  },
};
</script>
  
  <style>
</style>
  